import { useTranslation } from "react-i18next";
import { createFileRoute, Link } from "@tanstack/react-router";
import { buttonVariants } from "@/components/ui/button";
import { ClientCredentialList } from "@/components/ClientCredentials/ClientCredentialList";
import { API_DOCS_URL } from "@/routes/reset-password-success";

export const Route = createFileRoute("/_authenticated/client-credentials/")({
  component: ClientCredentialsPage,
});

function ClientCredentialsPage() {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto space-y-4 py-6">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col items-center justify-between gap-2 sm:flex-row">
          <h1 className="text-center text-3xl font-bold tracking-tight">{t("Client Credentials - API Access")}</h1>
          <Link className={buttonVariants({ className: "w-full sm:w-auto" })} to="/client-credentials/new">
            {t("Create Credential")}
          </Link>
        </div>
        <div className="text-sm text-muted-foreground">
          <p className="text-balance">
            {t("Client credentials")} <b>({t("Client ID and Client Secret")})</b>{" "}
            {t(
              "used for API access in conjunction with your API password and registered email address. Each credential can be configured with specific permissions to ensure controlled and secure access to authorized resources.",
            )}
          </p>
          <p className="text-balance">
            <Link to={API_DOCS_URL} target="_blank" className="text-xs">
              {t("API Documentation")}: <span className="underline">{API_DOCS_URL}</span>
            </Link>
          </p>
        </div>
      </div>
      <ClientCredentialList />
    </div>
  );
}
